<template>
    <div :id="componentId+'-plot_area'" class="row">
    </div>
</template>


<script>
/* eslint-disable */
import * as d3 from "d3";
import {loadingCircle} from "../mixins/D3Mixin";

export default {
    name: "BetaDiversityDissimilarityWidget",
    props: ["colorParameter", "plotData", "componentId", "pcPlotData"],
    mixins: [loadingCircle],

    data() {
        return {
            divId: this.componentId + '-plot_area'
        }
    },
    watch: {
        plotData: function () {
            this.drawScatterPlot()
        },
        colorParameter() {
            this.drawScatterPlot()
        },
        pcPlotData: function () {
            this.drawScatterPlot()
        }
    },
    mounted() {
        this.initSvg();
    },
    methods: {

        initSvg() {
            this.divElement = document.getElementById(this.divId)
            this.drawScatterPlot()
        },

        drawScatterPlot() {
            if (this.divElement.childNodes.length > 0) {
                while (this.divElement.firstChild) {
                    this.divElement.removeChild(this.divElement.lastChild);
                }
            }
            let margin = {top: 20, right: 20, bottom: 30, left: 40},
                width = 350 - margin.left - margin.right,
                height = 198 - margin.top - margin.bottom;
            if (this.plotData === null) {
                this.spinningCircle(margin, width, height)
            } else {
                if (this.plotData.length !== 0) {
                    let cssCol = "col-12"
                    let parameter = this.colorParameter
                    const subgroups = [...new Set(this.plotData.nmds_result.map(d => d[parameter]))]
                    const subgroupsLength = subgroups.reduce((t, d) => d.length > t ? d.length : t, 0) * 6
                    const margin = {top: 20, right: subgroupsLength + 25, bottom: 30, left: 40},
                        width = 350 - margin.left - margin.right + subgroupsLength + 2,
                        height = 300 - margin.left - margin.right + subgroupsLength + 2;

                    let id_clip = this.componentId + "_clip_path"
                    let svg = d3.select(this.divElement)
                        .append("svg")
                        .attr("class", cssCol)
                        .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
                        .append("g")
                        .attr("transform",
                        `translate(${margin.left}, ${margin.top})`);

                    let x_parameter_axis = d3.scaleLinear()
                        .range([0, 50])
                    let y_parameter_axis = d3.scaleLinear()
                        .range([height, height - 50]);

                    let x = d3.scaleLinear()
                        .range([0, width - 100]);

                    // Add Y axis-
                    let y = d3.scaleLinear()
                        .range([height, 100]);

                    let nmds1Extent = d3.extent(this.plotData.nmds_result, d => d.NMDS1);
                    let nmds2Extent = d3.extent(this.plotData.nmds_result, d => d.NMDS2);
                    let domain = [Math.min(nmds1Extent[0], nmds2Extent[0]), Math.max(nmds1Extent[1], nmds2Extent[1])];
                    let parameter_domain = [this.pcPlotData.domain.min, this.pcPlotData.domain.max]
                    x.domain(domain);
                    y.domain(domain);
                    y_parameter_axis.domain(parameter_domain);
                    x_parameter_axis.domain(parameter_domain);


                    let correlationData = []
                    if (this.pcPlotData) {
                        for (let i = 0; i < this.plotData.nmds_result.length; i++) {
                            let event = this.plotData.nmds_result[i]
                            let eventId = event.event_id
                            let pcSampleResult = this.pcPlotData.data.find(item => item.event_id === eventId);
                            if (pcSampleResult) {
                                correlationData.push({
                                    'event_id': eventId,
                                    'nmds1': event.NMDS1,
                                    'nmds2': event.NMDS2,
                                    'pcValue': pcSampleResult.value,
                                    'group': event[parameter]

                                })
                            }
                        }
                    }


                    const color = d3.scaleOrdinal()
                        .domain(subgroups)
                        .range(['#e6194B', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45',
                            '#fabed4', '#469990', '#dcbeff', '#9A6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1',
                            '#000075', '#a9a9a9', '#ffffff', '#000000'])

                    let yAxisGeneral = svg.append("g")
                        .attr("transform", `translate(100,-100)`)
                        .call(d3.axisLeft(y));
                    let xAxisGeneral = svg.append("g")
                        .attr("transform", `translate(100,${height - 100})`)
                        .call(d3.axisBottom(x));


                    let xAxisNMDS1 = svg.append("g")
                        .attr("transform", `translate(0,${height - 100})`)
                        .call(d3.axisBottom(x_parameter_axis).ticks(3));

                    let yAxisNMDS1 = svg.append("g")
                        .attr("transform", `translate(0,-100)`)
                        .call(d3.axisLeft(y));


                    let xAxisNMDS2 = svg.append("g")
                        .attr("transform", `translate(100,${height})`)
                        .call(d3.axisBottom(x));
                    let yAxisNMDS2 = svg.append("g")
                        .attr("transform", `translate(100,0)`)
                        .call(d3.axisLeft(y_parameter_axis).ticks(3));

                    // Add a clipPath: everything out of this area won't be drawn.
                    let clip = svg.append("defs").append("svg:clipPath")
                        .attr("id", id_clip)
                        .append("svg:rect")
                        .attr("width", width)
                        .attr("height", height)
                        .attr("x", 0)
                        .attr("y", 0)
                        .attr('fill', 'pink');


                    // Color scale: give me a species name, I return a color
                    let div = d3.select("body").append("div")
                        .attr("class", "tooltip")
                        .style("opacity", 0.5);



                    // Create the scatter variable: where both the circles and the brush take place
                    let scatter = svg.append('g')
                        .attr("clip-path", "url(#id_clip)")

                    // gridlines in y axis function
                    let me = this

                    // Add circles
                    scatter
                        .selectAll("circle")
                        .data(this.plotData.nmds_result)
                        .enter()
                        .append("circle")
                        .attr("cx", d => x(d.NMDS1) + 100)
                        .attr("cy", d => y(d.NMDS2) - 100)
                        .attr("r", 3)
                        .attr('fill', d => color(d[parameter]))
                        .style("opacity", 0.7)
                        .on("mouseover", function (event, d) {
                            div.transition()
                                .duration(200)
                                .style("opacity", 0.9);
                            div.html("NMDS1 : " + d.NMDS1.toFixed(3) + "<br>" + "NMDS2 : " + d.NMDS2.toFixed(3) + "<br>" + "Sample id : " + d.sample_id)
                                .style("background-color", '#005B60')
                                .style("color", 'white')
                                .style("border", "3px")
                                .style("left", (event.pageX) + "px")
                                .style("top", (event.pageY - 50) + "px");
                        })
                        .on("mouseout", function (d) {
                            div.transition()
                                .duration(500)
                                .style("opacity", 0);
                        });

                    svg.append("g")
                        .attr("id", "nmds1pccircles")
                        .selectAll("circle")
                        .data(correlationData)
                        .enter()
                        .append("circle")
                        .attr("cx", d => x(d.nmds1) + 100)
                        .attr("cy", d => y_parameter_axis(d.pcValue))
                        .attr("r", 2)
                        .attr('fill', d => color(d['group']))
                        .style("opacity", 0.7)
                        .on("mouseover", function (event, d) {
                            div.transition()
                                .duration(200)
                                .style("opacity", 0.9);
                            div.html("NMDS1 : " + d.nmds1.toFixed(3) + "<br>" + "NMDS2 : " + d.pcValue.toFixed(3) + "<br>" + "Sample id : " + d.event_id)
                                .style("background-color", '#005B60')
                                .style("color", 'white')
                                .style("border", "3px")
                                .style("left", (event.pageX) + "px")
                                .style("top", (event.pageY - 50) + "px");
                        })
                        .on("mouseout", function (d) {
                            div.transition()
                                .duration(500)
                                .style("opacity", 0);
                        });

                    svg.append("g")
                        .attr("id", "nmds2pccircles")
                        .selectAll("circle")
                        .data(correlationData)
                        .enter()
                        .append("circle")
                        .attr("cx", d => x_parameter_axis(d.pcValue))
                        .attr("cy", d => y(d.nmds2) - 100)
                        .attr("r", 2)
                        .attr('fill', d => color(d['group']))
                        .style("opacity", 0.7)

                    // Grid related to general plot
                    scatter.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(100,${height - 100})`)
                        .attr("stroke", "currentColor")
                        .attr("stroke-opacity", 0.1)
                        .call(d3.axisBottom(x)
                            .ticks(12)
                            .tickSize(-height + 100)
                            .tickFormat("")
                        )

                    scatter.append("g")
                        .attr("class", "grid")
                        .attr("transform", "translate(100, -100)")
                        .attr("stroke", "currentColor")
                        .attr("stroke-opacity", 0.1)
                        .call(d3.axisLeft(y)
                            .ticks(8)
                            .tickSize(-width + 100)
                            .tickFormat("")
                        )
                    // Grid related to NMDS1 vs env plot
                    scatter.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(100,${height})`)
                        .attr("stroke", "currentColor")
                        .attr("stroke-opacity", 0.1)
                        .call(d3.axisBottom(x)
                            .ticks(12)
                            .tickSize(-50)
                            .tickFormat("")
                        )

                    scatter.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(100,${height - 50})`)
                        .attr("stroke", "currentColor")
                        .attr("stroke-opacity", 0.1)
                        .call(d3.axisLeft(x_parameter_axis)
                            .ticks(4)
                            .tickSize(-width + 100)
                            .tickFormat("")
                        )

                    // Grid related to NMDS2 vs env plot
                    scatter.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(0,${height - 100})`)
                        .attr("stroke", "currentColor")
                        .attr("stroke-opacity", 0.1)
                        .call(d3.axisBottom(x_parameter_axis)
                            .ticks(4)
                            .tickSize(-height + 100)
                            .tickFormat("")
                        )

                    scatter.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(0,-100)`)
                        .attr("stroke", "currentColor")
                        .attr("stroke-opacity", 0.1)
                        .call(d3.axisLeft(y)
                            .ticks(12)
                            .tickSize(-50)
                            .tickFormat("")
                        )


                    svg.append("text")
                        .attr("text-anchor", "end")
                        .attr("x", width)
                        .attr("y", height + margin.top + 10)
                        .style("font-size", "70%")
                        .style("font-family", "Avenir, Helvetica, Arial, sans-serif")
                        .text("NMDS1");

                    svg.append("text")
                        .attr("text-anchor", "end")
                        .attr("transform", "rotate(-90)")
                        .attr("y", -margin.left + 10)
                        .attr("x", -margin.top)
                        .style("font-size", "70%")
                        .style("font-family", "Avenir, Helvetica, Arial, sans-serif")
                        .text("NMDS2")

                    let legend = svg.append('g')
                        .attr('class', 'legend')
                        .attr('transform', `translate(${width + 10}, 0)`);

                    legend.selectAll('rect')
                        .data(subgroups)
                        .enter()
                        .append('rect')
                        .attr('x', 0)
                        .attr('y', (d, i) => i * 12)
                        .attr('width', 10)
                        .attr('height', 10)
                        .attr('fill', (d) => color(d));
                    legend.selectAll('text')
                        .data(subgroups)
                        .enter()
                        .append('text')
                        .text(d => d)
                        .attr("font-size", "8px")
                        .attr('x', 14)
                        .attr('y', (d, i) => i * 12 + 1.5)
                        .attr('text-anchor', 'start')
                        .attr('alignment-baseline', 'hanging');

                    // A function that set idleTimeOut to null
                    let idleTimeout

                    function idled() {
                        idleTimeout = null;
                    }

                } else {
                    this.notEnoughData(margin, width, height)
                }

            }
        }
    }
}

</script>

<style scoped>
</style>